import { translate } from "app/filters/i18nFilter";
import { CPCGroupFilter, abbrFloatingNumberFilter } from "app/filters/ngFilters";
import { DIFFICULTY_LEVEL_WITH_LIMITS, getDifficultyLevel } from "app/common/difficulty/difficulty.utils";

import type { IStatsResponseData } from "app/common/keyword-research/keywords-overview/serpCompositionTypes";

import type { SerpMetricRowData } from "app/common/keyword-research/keywords-overview/serpMetricsConsts";

const cpcFilter = (value) => CPCGroupFilter()(value, abbrFloatingNumberFilter, [null, 2]);

export const transformSerpMetricsData = (rawData: IStatsResponseData): SerpMetricRowData => {
    const { Difficulty, Competition, CPCRangeMin, CPCRangeMax, TotalSpentRangeMin, TotalSpentRangeMax } = rawData;
    const difficulty = Difficulty && Math.round(Difficulty);
    const competition = Competition && Math.round(Competition);
    const organicRowData = {
        value: Difficulty && `${difficulty} - ${getDifficultyLevel(difficulty, DIFFICULTY_LEVEL_WITH_LIMITS)}`,
        change: null,
    };
    const paidRowData = {
        value: Competition && `${competition} - ${getDifficultyLevel(competition, DIFFICULTY_LEVEL_WITH_LIMITS)}`,
        change: null,
    };
    let cpcRowData;
    if (CPCRangeMin && CPCRangeMax && TotalSpentRangeMin && TotalSpentRangeMax) {
        cpcRowData = {
            value: cpcFilter(`${CPCRangeMin}-${CPCRangeMax}`),
            description: `${translate(
                "keyword.analysis.overview.page.v2.serp_metrics.cpc.description.prefix",
            )} ${cpcFilter(`${TotalSpentRangeMin}-${TotalSpentRangeMax}`)}`,
        };
    } else {
        cpcRowData = {
            value: undefined,
        };
    }

    return { organicRowData, paidRowData, cpcRowData };
};
